




import * as am4core from "@amcharts/amcharts4/core";
import am4themesAnimated from "@amcharts/amcharts4/themes/animated";
import { AmChart, RevenueSeries } from "@/models";
import XYChart from "@/service/charts/XYChart";
import { Component, Vue, Prop } from "vue-property-decorator";
import { State } from "vuex-class";
import { AuthState } from "@storage360/login/src/interfaces/auth-state";

am4core.useTheme(am4themesAnimated);

@Component({
  name: "XYGraph"
})
export default class XYGraph extends Vue {
  // ===== Store ===== //
  @State("auth") private readonly auth!: AuthState;
  // ===== Props ===== //
  @Prop(String) private readonly url!: string;
  @Prop(Array) private readonly series!: RevenueSeries[];
  @Prop(Boolean) private readonly rightAxis!: boolean;
  @Prop(Boolean) private readonly legend!: boolean;
  // ===== Data ===== //
  private chart: AmChart = {
    dispose: Function
  };
  // ===== Lifecycle Hooks ===== //
  private mounted() {
    this.chart = XYChart.getChart(
      this.$refs.chartdiv,
      this.url,
      this.series,
      this.rightAxis,
      this.legend,
      [{
        key: "Authorization",
        value: this.auth.access_token
      }]
    );
  }
  private beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
